import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ControlNameService } from '../services/control-name.service';
import { AbstractPropertyEditor } from '../types/property-editor.types';
import { ControlPropertyHandler } from './control-property-handler';

@Injectable({
  providedIn: 'root'
})
export class CascadeParentNamePropertyService implements ControlPropertyHandler<any> {
  propertyName: string = 'cascadeParentName';

  constructor(private nameService: ControlNameService) {}

  handleData(data: any, editor: AbstractPropertyEditor): Observable<any> {
    return this.nameService.handleCaseCadeParentName(data, editor);
  }
}
